"use client";
import { useState, useMemo } from 'react';
import CourseCard from './CourseCard';
import CoursesClientFallback from './CoursesClientFallback';
import { filterPublicCourses } from '../lib/courseVisibility';
import styles from '../courses.module.scss'; // Adjusted import path assuming it's up one level

export default function CoursesListAndFilter({ initialCourses, serverError }) {
    const [selectedLevel, setSelectedLevel] = useState('الكل');
    const [searchTerm, setSearchTerm] = useState('');

    const publicCourses = useMemo(
        () => filterPublicCourses(initialCourses || []),
        [initialCourses]
    );

    // If there's a server error, we render the client fallback directly, passing props doesn't make sense since it fetches its own data
    if (serverError) {
        return (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                <CoursesClientFallback />
            </div>
        );
    }

    // Determine unique levels from courses, or use defaults
    const levels = useMemo(() => {
        if (!publicCourses || publicCourses.length === 0) return ['الكل'];
        const uniqueLevels = new Set(['الكل']);
        publicCourses.forEach(course => {
            if (course.acf && course.acf.level) {
                 uniqueLevels.add(course.acf.level);
            }
        });
        return Array.from(uniqueLevels);
    }, [publicCourses]);


    const filteredCourses = useMemo(() => {
        let filtered = publicCourses || [];

        // Apply level filter
        if (selectedLevel !== 'الكل') {
            filtered = filtered.filter(course => course.acf?.level === selectedLevel);
        }

        // Apply search filter
        if (searchTerm.trim() !== '') {
            const lowerSearch = searchTerm.toLowerCase();
            filtered = filtered.filter(course => {
                const title = course.title?.rendered || '';
                return title.toLowerCase().includes(lowerSearch);
            });
        }

        return filtered;
    }, [publicCourses, selectedLevel, searchTerm]);

    return (
        <>
            {/* Filter Bar */}
             <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
                <div className="d-flex gap-2 flex-wrap">
                    {levels.map((level) => (
                        <button
                            key={level}
                            onClick={() => setSelectedLevel(level)}
                            className={`btn rounded-pill px-4 py-2 ${selectedLevel === level
                                ? 'btn-primary'
                                : 'btn-outline-secondary'
                                }`}
                        >
                            {level}
                        </button>
                    ))}
                </div>
                <div className="d-flex gap-2">
                    <input
                        type="text"
                        placeholder="ابحث عن دورة..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="form-control rounded-pill"
                        style={{ maxWidth: '250px' }}
                    />
                </div>
            </div>

            {/* Courses Grid */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {filteredCourses.length > 0 ? (
                    filteredCourses.map((course) => (
                        <div key={course.id} className="col">
                            <CourseCard course={course} />
                        </div>
                    ))
                ) : (
                    <div className="col-12 text-center py-5">
                        <p className="text-muted">لا يوجد دورات مطابقة للبحث أو التصفية.</p>
                    </div>
                )}
            </div>
        </>
    );
}
